import type { FaireProductEntity } from "../../entity_types/product";

export const p_qt38p5ptuj: FaireProductEntity = {
  token: "p_qt38p5ptuj",
  type: "product",
  name: "Sanrio Hello Kitty And Friends Fruit-Flavored Candy Bracelets (20ct)",
  brandToken: "b_8688sz59tv",
  brandName: "Showcase",
  imageUrl: "https://cdn.faire.com/fastly/3bae4c0ea5db1eecf0ed96048fa7d88cb027a609fb34126fcb36579eb4d2f393.jpeg",
  galleryImageUrls: [],
  priceDollars: 3.99,
  description: "Wear It, Share It & Trade It with Hello Kitty and Friends!\n\nCandy and Sanrio® in one box, two things kids already ask for by name. Each bracelet is strung with colorful fruit flavored candy pieces and finished with a cute Sanrio® character charm, so kids wear it, show off their favorite character, trade with friends, then eat it.\n\nAt 20 bracelets per box, these work as a single item grab at the register or a whole box for birthday parties, goodie bags and classroom exchanges. Hello Kitty fans of every age stop for this one, which makes it an easy add on near checkout or in your candy and party aisles.\n\n🍬 20 edible candy bracelets per box\n🍓 Assorted fruit flavors\n🎀 Each bracelet has a Sanrio® character charm\n💖 Features Hello Kitty and Friends designs\n🤝 Fun to wear, share and trade\n🎉 Great for parties, goodie bags, party favors and gifting\n🛒 Strong impulse buy for checkout, candy and party displays\n⚖️ Net weight: 6.7 oz\n\nShowcase® is an authorized retailer of Sanrio®\n",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:00:38.841Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
